import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Jira Reverse Trial Plan Selection Modal.
 * Shown to billing admins in Jira reverse trial (in trial or predunning).
 */
export function isEligibleForReverseTrialPlanSelection(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInReverseTrial,
		userRoles,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
		canUpgrade,
	} = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['premium']) &&
		product === 'jira' &&
		(isInTrial || isInPredunning) &&
		isInReverseTrial &&
		userRoles?.includes('BILLING_ADMIN') &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		(!fg('flymodst-113-fix-confluence-jira-rt-ea-plan-select') || canUpgrade),
	);
}
